/* eslint-disable react/jsx-props-no-spreading */

'use client';

import type * as React from 'react';

import { Button } from '@coop/cds-components';
import { useInitialFocus } from '@coop/hooks';
import { useRef } from 'react';

import { type ButtonProps } from '../Button';
import NotificationContent from './NotificationContent';

const PermanentNotification = (
    props: React.ComponentProps<typeof NotificationContent> & {
        ctaProps?: ButtonProps;
        useInitialCtaFocus?: boolean;
    },
) => {
    const leastDestructiveActionRef = useRef<HTMLButtonElement>(null);
    useInitialFocus(leastDestructiveActionRef, !!props.useInitialCtaFocus && !!props.ctaProps);

    return (
        <NotificationContent
            show={props.show}
            type={props.type}
            iconSlot={props.iconSlot}
            header={props.header}
            message={props.message}
            size={props.size}
            theme={props.theme}
            asModal={props.asModal}
            bottomSlot={
                !!props.ctaProps && (
                    <Button
                        ref={leastDestructiveActionRef}
                        {...props.ctaProps}
                        theme={(() => {
                            switch (props.type) {
                                case 'alert':
                                    return 'destructive';
                                default:
                                    return 'primary';
                            }
                        })()}
                    />
                )
            }
        />
    );
};

export default PermanentNotification;
